import React from "react";
import PropTypes from "prop-types";
import EnergyChartLegend from "./EnergyChartLegend";

const EnergyChartFooter = props => <EnergyChartLegend {...props} />;

EnergyChartFooter.propTypes = {
  hasBaseline: PropTypes.bool,
  showStoreClosedCheckbox: PropTypes.bool,
  showStoreClosedOverlay: PropTypes.bool,
  callbackFromParent: PropTypes.func,
  actualsSeriesLabel: PropTypes.string.isRequired,
  hasAlerts: PropTypes.bool
};

EnergyChartFooter.defaultProps = {
  hasBaseline: true,
  showStoreClosedCheckbox: true,
  showStoreClosedOverlay: false
};

export default EnergyChartFooter;
